import { ApiOptionsParams } from 'app/components/options-handler/types';
import { RemoteAdminData, RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { CodetableWireFormat } from 'app/infrastructure/ui/form/types-codetable';
import { ApiResponse, HttpResponse, RequestRemoteApi } from 'app/types-shared';
import { endpoints } from './endpoints';

const getRemoteData = (requestRemoteApi: RequestRemoteApi, componentEndpoint: string) => ({
  [RequestRemoteApi.adminApi]: new RemoteAdminData(componentEndpoint),
  [RequestRemoteApi.servicesApi]: new RemoteData(componentEndpoint)
}[requestRemoteApi] ?? new RemoteData(componentEndpoint));

export const api = {

  getOptions: ({
    componentEndpoint,
    optionsRequestParams,
    optionsParams,
    requestRemoteApi
  }: ApiOptionsParams): Promise<HttpResponse<ApiResponse<any>>> =>
    getRemoteData(requestRemoteApi, componentEndpoint)
      .resource<HttpResponse<ApiResponse<any>>>()
      .filter({
        ...optionsRequestParams,
        ...optionsParams
      }).all(),

  postOptions: async ({
    componentEndpoint,
    optionsRequestParams,
    optionsParams,
    optionsRequestPayload,
    requestRemoteApi
  }: ApiOptionsParams): Promise<any> => {
    const response = await getRemoteData(requestRemoteApi, componentEndpoint)
      .resource<any>()
      .filter({
        ...optionsRequestParams,
        ...optionsParams
      }).create(optionsRequestPayload);

    return await response.json();
  },

  loadPath: async (codetableId: number, codeId: number): Promise<CodetableWireFormat> => {
    const response = await new RemoteAdminData(endpoints.optionPath(codetableId, codeId))
      .resource<ApiResponse<any>>()
      .single();

    return response.data;
  }
};
